module.exports = __webpack_public_path__ + "img/鲁河镇-c.9656e61a.png";